import {
  Building2,
  Hotel,
  Utensils,
  Factory,
  School,
  Landmark,
  Store,
  Trees,
  Umbrella,
  Sparkles,
  BriefcaseBusiness,
  Blocks,
  Warehouse,
  Wrench,
} from 'lucide-react';
import { motion } from 'framer-motion';
import SectionHeading from './SectionHeading';
import { services } from '@/lib/siteData';

const icons = [
  BriefcaseBusiness,
  Building2,
  Hotel,
  Utensils,
  Factory,
  School,
  Landmark,
  Store,
  Landmark,
  Trees,
  Blocks,
  Warehouse,
  Umbrella,
  Wrench,
];

const Services = () => {
  return (
    <section id="servicios" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Cobertura integral"
          title="SOLUCIONES PROFESIONALES DE LIMPIEZA"
          text="Servicios adaptados a las necesidades de cada instalación."
        />

        <div className="mt-14 grid gap-px bg-slate-200 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {services.map(([title, description], index) => {
            const Icon = icons[index] || Sparkles;
            return (
              <motion.article
                key={title}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: (index % 4) * 0.05 }}
                className="group bg-white p-7 transition hover:bg-[#0A2540]"
              >
                <Icon className="transition group-hover:text-emerald-400 text-[#00a7e2]" />
                <h3 className="mt-8 font-bold uppercase text-[#0A2540] group-hover:text-white">
                  {title}
                </h3>
                <p className="mt-3 text-sm leading-6 text-slate-600 group-hover:text-blue-100 text-justify">
                  {description}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;